import { useEffect } from "react";

export const useClickAwayClose = (elementShowing: boolean, ref: React.RefObject<HTMLElement>, onHideElement: () => void) => {
    
    useEffect(() => {
        const handleMouseDown = (event: MouseEvent) => {
            if (elementShowing && ref.current && !ref.current.contains(event.target as Node)) {
                onHideElement();
            }
        };

        document.addEventListener("click", handleMouseDown);

        return () => {
            document.removeEventListener("click", handleMouseDown);
        };
    }, [elementShowing]);
};
